import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { VoucherPurchaseService } from './shared/services/voucher-purchase.service';
import { VoucherPurchaseComponent } from './purchase/voucher-purchase.component';
import { RecaptchaModule, RecaptchaFormsModule }from "ng-recaptcha";
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';



@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskDirective,
    RecaptchaModule,
    RecaptchaFormsModule
  ],
  declarations: [
    VoucherPurchaseComponent
  ],
  providers: [VoucherPurchaseService, provideNgxMask()]
})
export class VoucherPurchaseModule { }
